var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'referral-list',
  created () {
    this.search()
  },
  data () {
    return {
      shopName: '',
      searchCallbackFlag: false,
      referrals: ''
    }
  },
  computed: {
  },
  components: {
    AppHeader
  },
  methods: {
    search: function () {
      let data = {
        shop_name: this.shopName
      }
      this.$store
        .dispatch('GET_REFERRAL_LIST', { data: data })
        .then(res => {
          this.referrals = res
          this.searchCallbackFlag = true
        })
        .catch(err => console.log(err))
    },
    isPublish: function (data) {
      return data === 1 ? true : false
    },
    changePublish: function (referralId, isPublish, workStyle, index) {
      if (window.confirm('公開状態を変更しますか？\n※即時変更されます')) {
        let data = {
          referral_id: referralId,
          is_publish: isPublish === 0 ? 1 : 0
        }
        this.$store.dispatch('CHANGE_PUBLISH', { data: data })
        .then(res => {
          this.referrals[index][workStyle]['is_publish'] = isPublish === 0 ? 1 : 0
          this.$forceUpdate()
        })
        .catch(err => console.log(err))
      } else {
        this.$forceUpdate()
      }
    },
    isChecked: function (isPublish) {
      return isPublish === 1 ? true : false
    },
    goReferralEdit: function (referralId) {
      this.$router.push({path: `/referral/${referralId}/edit`})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/referral-list.js